var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"container"},[_c('img-v3',{attrs:{"src":_vm.formItem.img_url},on:{"click":_vm.goLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }